import { RoutesConfig } from './routes';

// Buyer has both orders and quotations, so when a pathname is provided we keep
// the user within the flow they came from (quotations vs orders).
export const isBuyerQuotationFlowPath = (pathname?: string): boolean =>
  !!pathname &&
  (pathname.includes(RoutesConfig.BuyerQuotations.fullPath) ||
    pathname.includes(RoutesConfig.BuyerNewQuotation.fullPath));

// State carried into the configurator sub pages (BOM, Specs). Their own
// pathname says nothing about the flow the user is configuring in - both are
// reached from the order and the quotation flow alike - so the pathname of the
// page holding the configurator travels with the navigation and decides where
// Back leads.
export interface IConfiguratorSubPageState {
  backFromBomPage?: boolean;
  configuratorPathname?: string;
}

export const buildConfiguratorSubPageState = (location: {
  pathname: string;
  state: unknown;
}): IConfiguratorSubPageState => ({
  ...(location.state as IConfiguratorSubPageState),
  configuratorPathname: location.pathname,
});
